import {makeLocalStorageAdapter} from 'main/factories/cache';
import {AccountData} from 'presentation/pages/private/store/useAccountDataStateStore/types';
import {ACCOUNT_STORAGE_KEY} from 'presentation/pages/private/store/useAccountDataStateStore/constants';

export const getCurrentAccountAdapter = (): AccountData =>
	makeLocalStorageAdapter<AccountData>().get(ACCOUNT_STORAGE_KEY);
